import { isLoanFutureType } from "web_myplann/Goals/Helpers/futureContractForm";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";

export const getGoalMonthlySavings = (
	goal: Pick<GoalDetail, "futurePortfolios">,
): number =>
	goal.futurePortfolios
		.filter((portfolio) => !isLoanFutureType(portfolio.type))
		.reduce((sum, portfolio) => sum + (portfolio.monthlyAmount ?? 0), 0);
